import React, { Component } from 'react';
import styled from 'styled-components';
import {
  Box,
  Button,
  Card,
  Flex,
  Heading,
} from 'rebass';
import { Formik, Form } from 'formik';
import TextInput from '../components/TextInput';
import { FormField } from '../components/FormField';
import { ADMIN_CHANGE_STRIPE_ID } from '../graphql';
import { compose, withApollo } from 'react-apollo';
import { withToastManager } from 'react-toast-notifications';

const Container = styled(Box)`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  padding-top: 48px;
`;

class ChangeStripeId extends Component {
  handleSubmit = async (values, actions) => {
    actions.setSubmitting(true);

    try {
      const res = await this.props.client.mutate({
        mutation: ADMIN_CHANGE_STRIPE_ID,
        variables: {
          stripeId: values.stripeId,
          athenaId: values.athenaId,
        },
      });
      
      if (res && res.data && res.data.changeStripeId) {
        if (res.data.changeStripeId.ok === true) {
          actions.resetForm();
          this.props.toastManager.add('Updated successfully', {
            appearance: 'success',
          });
        } else {
          this.props.toastManager.add(
            res.data.changeStripeId.customError.userMessage ||
              'Error updating',
            { appearance: 'error' }
          );
          console.log(
            'Unable to update email: ',
            res.data.changeStripeId.customError.errorMessage
          );
        }
      } else {
        actions.setSubmitting(false);
        this.props.toastManager.add('Error updating, please try again', {
          appearance: 'error',
        });
      }

      actions.setSubmitting(false);
      //   toastManager.add('Error submitting intake form', { appearance: 'error' });
    } catch (err) {
      console.log('changeStripeId Err', err);
      actions.setSubmitting(false);
      this.props.toastManager.add('Error updating, please try again', {
        appearance: 'error',
      });
    }
  };
  
  render() {
    return (
      <Container>
        <Flex m={[3, 5]} flex={1} flexDirection="column">
          <Heading mb={4} mt={[3, 0]} ml={[1, 0]} fontSize={[4, 5]}>
            Change patient's Stripe ID
          </Heading>
          <Card mb={4} p={[3, 4]}>
            <Flex flexDirection={'column'} flex={1} alignItems="center">
              <Formik
                initialValues={{ oldemail: '', newemail: '' }}
                // validationSchema={schema}
                onSubmit={(values, actions) =>
                  this.handleSubmit(values, actions)
                }
                render={({
                  errors,
                  touched,
                  isValid,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                  values,
                }) => (
                  <Form style={{ width: '300px' }}>
                    <Flex flexDirection="column" flex={1}>
                      <Heading mb={4}>Athena ID</Heading>
                    </Flex>
                    <FormField mb={4} error={touched.athenaId && errors.athenaId}>
                      <TextInput
                        placeholder="Athena Id"
                        name="athenaId"
                      />
                    </FormField>
                    <Flex flexDirection="column" flex={1}>
                      <Heading mb={4}>New Stripe Id</Heading>
                    </Flex>
                    <FormField mb={4} error={touched.stripeId && errors.stripeId}>
                      <TextInput
                        placeholder="New Stripe ID"
                        type="text"
                        name="stripeId"
                      />
                    </FormField>

                    <Button
                      mt={4}
                      mb={4}
                      variant="primary"
                      width={1 / 2}
                      disabled={!isValid || isSubmitting}
                      type="submit"
                    >
                      Change
                    </Button>
                  </Form>
                )}
              />
            </Flex>
          </Card>
        </Flex>
      </Container>
    );
  }
}

export default compose(
  withApollo,
  withToastManager
)(ChangeStripeId);
